var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// @ts-ignore
import { useMutation, useQuery,
// @ts-ignore
 } from 'react-query';
import api from '../../api/client';
import { mapDatesFromApiResponse } from '../../utilities/dates';
import { attachmentsKeys } from './attachments.keys';
export var AttachmentEventType = ['Conference', 'Collaboration Request'];
function getAttachments(eventId, type, responseId) {
    return __awaiter(this, void 0, void 0, function () {
        var config;
        return __generator(this, function (_a) {
            config = { containsPHI: true };
            return [2 /*return*/, api
                    .get("/api/eventattachments?filters=".concat(type === 'Conference' ? 'caseId' : 'collaborationRequestId', "==").concat(eventId, ",SpecialtyInputResponseId==").concat(responseId || 'null', "&SortOrder=SortOrder"), config)
                    .then(function (response) {
                    var responseData = response.data;
                    mapDatesFromApiResponse(responseData.data);
                    responseData.data.forEach(function (item) {
                        var _a, _b;
                        // eslint-disable-next-line no-param-reassign
                        item.url =
                            item.url &&
                                (((_a = item.url) === null || _a === void 0 ? void 0 : _a.includes('aws:4566'))
                                    ? (_b = item.url) === null || _b === void 0 ? void 0 : _b.replace('aws:4566', 'localhost:4010')
                                    : item.url);
                    });
                    return responseData.data;
                })];
        });
    });
}
function useGetAttachments(eventId, type, responseId, options) {
    var _this = this;
    return useQuery(attachmentsKeys.list(eventId, responseId), function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, getAttachments(eventId, type, responseId)];
    }); }); }, 
    // @ts-ignore
    options);
}
function createConferenceAttachment(eventId, data, onProgress) {
    return __awaiter(this, void 0, void 0, function () {
        var config;
        return __generator(this, function (_a) {
            config = { containsPHI: true, timeout: 120000 };
            return [2 /*return*/, api
                    .post("/api/eventattachments/conference/".concat(eventId), data, __assign({ onUploadProgress: onProgress }, config))
                    .then(function (response) { return response.data.data; })];
        });
    });
}
function createCollaborationAttachment(collaborationRequestId, data, onProgress) {
    return __awaiter(this, void 0, void 0, function () {
        var config;
        return __generator(this, function (_a) {
            config = { containsPHI: true };
            return [2 /*return*/, api
                    .post("/api/eventattachments/collaboration/".concat(collaborationRequestId), data, __assign({ onUploadProgress: onProgress }, config))
                    .then(function (response) { return response.data.data; })];
        });
    });
}
function deleteAttachment(id) {
    return __awaiter(this, void 0, void 0, function () {
        var config;
        return __generator(this, function (_a) {
            config = { containsPHI: true };
            return [2 /*return*/, api
                    .delete("/api/eventattachments/".concat(id), config)
                    .then(function (response) { return response.data; })];
        });
    });
}
function useDeleteAttachment() {
    var _this = this;
    return useMutation(function (id) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, deleteAttachment(id)];
    }); }); });
}
function updateAttachment(id, data) {
    return __awaiter(this, void 0, void 0, function () {
        var config;
        return __generator(this, function (_a) {
            config = { containsPHI: true };
            return [2 /*return*/, api
                    .put("/api/eventattachments/".concat(id), data, config)
                    .then(function (response) { return response.data.data; })];
        });
    });
}
function useUpdateAttachment(options) {
    var _this = this;
    return useMutation(function (_a) {
        var id = _a.id, data = _a.data;
        return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_b) {
            return [2 /*return*/, updateAttachment(id, data)];
        }); });
    }, options);
}
function updateAttachmentSortOrder(newOrder) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, api.put('/api/eventattachments/sortorder', newOrder)];
        });
    });
}
function useUpdateAttachmentSortOrder() {
    var _this = this;
    return useMutation(function (newOrder) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, updateAttachmentSortOrder(newOrder)];
    }); }); });
}
function getEventPresignedAttachment(eventGuid, attachmentEventType) {
    return __awaiter(this, void 0, void 0, function () {
        var config, url;
        return __generator(this, function (_a) {
            config = { containsPHI: true };
            url = attachmentEventType === 'Conference'
                ? "/api/events/".concat(eventGuid, "/attachments")
                : "/api/collaborationrequests/".concat(eventGuid, "/attachments");
            return [2 /*return*/, api.get(url, config).then(function (response) {
                    var _a, _b;
                    var nonLocalEnvironments = new Set(['uat', 'prod', 'staging']);
                    var local = !nonLocalEnvironments.has(
                    // @ts-ignore
                    (_b = (process.env.REACT_APP_ENV || ((_a = import.meta.env) === null || _a === void 0 ? void 0 : _a.VITE_ENV))) !== null && _b !== void 0 ? _b : 'local');
                    var dto = response.data.data;
                    if (local) {
                        var attachments = dto !== null && dto !== void 0 ? dto : [];
                        attachments.forEach(function (a) {
                            var _a;
                            // eslint-disable-next-line no-param-reassign
                            a.url = ((_a = a.url) !== null && _a !== void 0 ? _a : '').replace('aws:4566', 'localhost:4010');
                        });
                    }
                    return dto;
                })];
        });
    });
}
function useEventPresignedAttachments(id, attachmentEventType, options) {
    var _this = this;
    return useQuery(attachmentsKeys.presignedAttachmentsDetail(id), 
    // @ts-ignore
    function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, getEventPresignedAttachment(id, attachmentEventType)];
    }); }); }, __assign({}, options));
}
export { getAttachments, useDeleteAttachment, createConferenceAttachment, createCollaborationAttachment, updateAttachment, useUpdateAttachment, useGetAttachments, useEventPresignedAttachments, getEventPresignedAttachment, useUpdateAttachmentSortOrder, };
